/**
 * 部门树工具类 - 简化版
 * 原 organization 模块迁移至此
 */
class DepTreeUtils {
    private static instance: DepTreeUtils;

    public static getInstance(): DepTreeUtils {
        if (!DepTreeUtils.instance) {
            DepTreeUtils.instance = new DepTreeUtils();
        }
        return DepTreeUtils.instance;
    }

    /**
     * 初始化树形数据
     */
    public InitTreeData(items: any[]): any[] {
        if (!items || !Array.isArray(items)) {
            return [];
        }
        return items.map(item => ({
            key: item.id || item.key,
            title: item.displayName || item.name || item.title,
            value: item.id || item.key,
            children: item.children ? this.InitTreeData(item.children) : []
        }));
    }

    /**
     * 根据角色初始化树形数据
     */
    public InitTreeDataByRoles(items: any[]): any[] {
        return this.InitTreeData(items);
    }

    /**
     * 初始化选择数据
     */
    public InitSelectData(res: any): any[] {
        if (!res || !res.items) {
            return [];
        }
        return res.items.map(item => ({
            key: item.id || item.key,
            title: item.displayName || item.name || item.title,
            value: item.id || item.key,
            isLeaf: !item.children || item.children.length === 0
        }));
    }

    /**
     * 数组映射到树
     */
    public ArrMapTree(ouData: any[], treeData: any[], isVirtual: boolean): any[] {
        if (!ouData || !Array.isArray(ouData)) {
            return treeData || [];
        }

        const result = ouData.map(item => ({
            ...item,
            key: item.id || item.key,
            title: item.displayName || item.name || item.title,
            value: item.id || item.key,
            children: item.children && item.children.length > 0
                ? this.ArrMapTree(item.children, [], isVirtual)
                : []
        }));

        return result;
    }

    /**
     * 数组转树
     */
    public ArrToTree(tableTree: any[], tableData: any[], flag: boolean): any[] {
        if (!tableTree || !Array.isArray(tableTree)) {
            return tableData || [];
        }

        // 构建父子关系
        const nodeMap = new Map();
        const roots: any[] = [];

        tableTree.forEach(node => {
            nodeMap.set(node.id || node.key, {
                ...node,
                key: node.id || node.key,
                title: node.displayName || node.name || node.title,
                value: node.id || node.key,
                children: []
            });
        });

        tableTree.forEach(node => {
            const parentId = node.parentId || node.parentid;
            const currentNode = nodeMap.get(node.id || node.key);

            if (parentId && nodeMap.has(parentId)) {
                const parentNode = nodeMap.get(parentId);
                parentNode.children.push(currentNode);
            } else {
                roots.push(currentNode);
            }
        });

        return roots;
    }
}

export default DepTreeUtils;
